import ClientRepository from "@domain/repositories/ClientRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";

type Input = Client["id"];

type Output = Promise<Client>;

export class GetClientUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientRepository: ClientRepository) {}

  async execute(clientId: Input) {
    return this.clientRepository.get(clientId);
  }
}
